export const INVESTMENT_TRANSACTION_STATUS_LABELS = {
  DFT: "Draft",
  SUB: "Submitted",
  CAN: "Cancelled",
};

export const INVESTMENT_TRANSACTION_STATUS_OPTIONS = Object.entries(
  INVESTMENT_TRANSACTION_STATUS_LABELS
).map(([value, label]) => ({ value, label }));

export const getInvestmentTransactionStatusLabel = (status, t) => {
  if (!status) return "";
  const key = `investmentTransactionStatus.${status}`;
  const translated = t(key, { defaultValue: "" });
  if (translated && translated !== key) return translated;
  return INVESTMENT_TRANSACTION_STATUS_LABELS[status] ?? status;
};
